import { render } from "./CoordsTable.vue?vue&type=template&id=8c487a56"
import script from "./CoordsTable.vue?vue&type=script&lang=js"
export * from "./CoordsTable.vue?vue&type=script&lang=js"

import "./CoordsTable.vue?vue&type=style&index=0&id=8c487a56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__